import { LogoIcon } from '@/components/SvgIcons/LogoIcon';
import { LogoTextIcon } from '@/components/SvgIcons/LogoTextIcon';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

interface LuciusLogoProps {
  linkTo?: string;
  containerClassName?: string;
  logoIconClassName?: string;
  logoTextWrapperClassName?: string;
  logoTextClassName?: string;
  children?: React.ReactNode;
}

export const LuciusLogo = ({
  linkTo = '/',
  containerClassName,
  logoIconClassName,
  logoTextWrapperClassName,
  logoTextClassName,
  children,
}: LuciusLogoProps) => {
  return (
    <Link
      className={twMerge('flex items-center gap-[9.5px]', containerClassName)}
      to={linkTo}
    >
      <LogoIcon className={twMerge('w-[32.85px] h-auto', logoIconClassName)} />
      <div className={twMerge('-mt-0.5', logoTextWrapperClassName)}>
        <LogoTextIcon
          className={twMerge(
            'w-[87.5px] h-auto dark-mode:[&>path:nth-child(2)]:fill-white dark-mode:[&>g[clip-path]>path:nth-child(2)]:fill-white',
            logoTextClassName
          )}
        />
        {children}
      </div>
    </Link>
  );
};
